import { useState } from 'react'

function useJobLog() {
    const [fetchingLogs, setFetchingLogs] = useState();

    const fetchLogs = async (jobId) => {
        setFetchingLogs(true);
        try {
            const res = await fetch(`/sis/jobs/${jobId}/logs`);
            if (res.ok) {
                const data = await res.json();
                const newWindow = window.open();
                newWindow.document.write('<pre>' + (data && data.logs && data.logs.join('<br>')) + '</pre>');
            } else {
                alert("Fetch logs error! " + res.statusText);
            }
        } catch (error) {
            alert("Fetch logs error! " + error.message);
        }
        setFetchingLogs(false);
    }

    return { fetchLogs, fetchingLogs };
}

export default useJobLog
